import { useQuery } from '@tanstack/react-query'
import { api } from '../../lib/api.js'
import { Spinner } from '../../components/ui.jsx'

/**
 * Diagnóstico de las cinco dependencias de una vez.
 * Los tres fallos de despliegue que tuvimos fueron el mismo patrón: un valor correcto en
 * desarrollo y equivocado en el contenedor. Aquí se ven todos juntos.
 */
export function Health() {
  const q = useQuery({ queryKey: ['health'], queryFn: api.health, refetchInterval: 30_000, retry: false })
  const data = q.data ?? q.error?.body

  return (
    <div className="main" style={{ margin: '0 auto' }}>
      <h1 className="h1">Diagnóstico</h1>
      <p className="lede">Estado de las dependencias externas de la consola.</p>

      {q.isPending && <Spinner />}

      {data?.checks && (
        <>
          {data.fallos > 0 && (
            <div className="alert error" style={{ marginBottom: 16 }}>
              {data.fallos} de {data.checks.length} dependencias no responden.
            </div>
          )}
          <div className="card">
            <div className="table-scroll">
              <table className="t">
                <thead>
                  <tr><th>Dependencia</th><th>Estado</th><th>Configuración</th><th style={{ textAlign: 'right' }}>ms</th></tr>
                </thead>
                <tbody>
                  {data.checks.map((c) => (
                    <tr key={c.nombre}>
                      <td>{c.nombre}</td>
                      <td>
                        <span className={`badge ${c.ok ? 'done' : 'error'}`}>
                          <span className="dot" />{c.ok ? c.detail : 'error'}
                        </span>
                        {!c.ok && (
                          <>
                            <div style={{ color: 'var(--danger)', fontSize: 12, marginTop: 5 }}>{c.error}</div>
                            {c.hint && <div style={{ color: 'var(--fg-3)', fontSize: 12, marginTop: 3 }}>{c.hint}</div>}
                          </>
                        )}
                      </td>
                      <td className="mono ellipsis" style={{ color: 'var(--fg-3)', fontSize: 12 }}>{c.url ?? '—'}</td>
                      <td className="num" style={{ color: 'var(--fg-2)' }}>{c.ms}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {data.listaDeAcceso && (
            <div className="card card-pad" style={{ marginTop: 16 }}>
              <strong>Quién puede entrar en la consola</strong>
              <p className="lede" style={{ margin: '4px 0 10px' }}>
                Solo estos usuarios de GitLab. Se comprueba al entrar y en cada petición; cambiarlo
                exige redesplegar con otro <code>CONSOLE_ALLOWED_USERS</code>.
              </p>
              <div className="toolbar">
                {data.listaDeAcceso.map((u) => (
                  <span key={u} className="badge done" style={{ fontFamily: 'var(--mono)' }}>
                    <span className="dot" />{u}
                  </span>
                ))}
              </div>
            </div>
          )}

          {data.proyectosProtegidos?.length > 0 && (
            <div className="card card-pad" style={{ marginTop: 16 }}>
              <strong>Proyectos protegidos</strong>
              <p className="lede" style={{ margin: '4px 0 10px' }}>
                Solo los ve y los toca un administrador de la plataforma. Para el resto{' '}
                <strong>no existen</strong>: ni en el listado, ni por URL, ni en el editor SQL.
              </p>
              <div className="toolbar">
                {data.proyectosProtegidos.map((p) => (
                  <span key={p} className="badge done" style={{ fontFamily: 'var(--mono)' }}>
                    <span className="dot" />{p}
                  </span>
                ))}
              </div>
            </div>
          )}

          <p className="lede" style={{ marginTop: 14, fontSize: 13 }}>
            Las contraseñas se enmascaran pero se muestra su longitud: es lo que delata un valor
            mal copiado.
          </p>
        </>
      )}
    </div>
  )
}
